// CTV-421: rerun targets come back from the API as a flat string[] in
// campaign.targetMarkets (the parsed form of target_geographies). Sniff the
// format the same way OrderReceipt does so the new wizard reopens with the
// correct geo tab pre-selected, not "default + empty selections".
//
// Empty input → default mode (no geo restriction).
//
// CTV-502: the standalone ZIP-codes tab was removed. Both legacy
// explicit-ZIP submissions and radius submissions persisted as 5-digit
// ZIPs in target_geographies, so all-numeric reruns now land on the
// Radius tab with `geoTargetZips` pre-loaded. The buyer keeps the same
// resolved list and can re-pick an address/radius if they want to
// regenerate it.
//
// Lives in its own module (rather than campaignActions.tsx) so the
// react-refresh/only-export-components ESLint rule stays happy — JSX
// component files can't co-export plain helpers without breaking fast
// refresh during local dev.

export function rerunGeoFields(targetMarkets: string[] | undefined): {
  targetingMode: 'default' | 'custom';
  geoMode: 'states' | 'dmas' | 'radius';
  selectedStates: string[];
  selectedDMAs: string[];
  geoTargetZips: string[];
} {
  const codes = (targetMarkets ?? []).filter((c) => typeof c === 'string' && c.length > 0);
  if (codes.length === 0) {
    return {
      targetingMode: 'default',
      geoMode: 'radius',
      selectedStates: [],
      selectedDMAs: [],
      geoTargetZips: [],
    };
  }
  if (codes.every((c) => /^\d{5}$/.test(c))) {
    return {
      targetingMode: 'custom',
      geoMode: 'radius',
      selectedStates: [],
      selectedDMAs: [],
      geoTargetZips: codes,
    };
  }
  if (codes.every((c) => /^[A-Z]{2}$/.test(c))) {
    return {
      targetingMode: 'custom',
      geoMode: 'states',
      selectedStates: codes,
      selectedDMAs: [],
      geoTargetZips: [],
    };
  }
  return {
    targetingMode: 'custom',
    geoMode: 'dmas',
    selectedStates: [],
    selectedDMAs: codes,
    geoTargetZips: [],
  };
}
